import React from "react";

const AuthLayout = ({ children }) => {
  const bgImage = require("../assets/images/auth-bg.png").default;
  const backgroundStyles = {
    backgroundImage: `url(${bgImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  };

  return (
    <div
      className="mx-auto min-h-screen flex flex-col items-center justify-center text-center text-sm sm:text-base bg-black"
      style={backgroundStyles}
    >
      <div className="w-[39%] max-[1240px]:w-[45%]  max-[1100px]:w-[46%] max-[1022]:w-1/6 max-[860px]:w-1/2">{children}</div>
    </div>
  );
};

export default AuthLayout;
